import React, { useRef } from "react";
import Button from "../Button";
import axios from "axios";
import { useState, useEffect, } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { editWaypoint, setWaypoint, startTyping, stopTyping } from "../../features/Waypoint/WaypointSlice";
import RangedInput from './RangedInput'
import { useNotification } from "../../context/NotificationContext";

//STATE 
//EDITING
//INTERVAL



export default function Waypoint() {
  const waypoint_north = useAppSelector(state => state.Waypoint.north);
  const waypoint_east = useAppSelector(state => state.Waypoint.east);

  const dispatch = useAppDispatch()
  const { notify } = useNotification();
  
  const handleInput = (event: any, dir: string) => {
    dispatch(startTyping());
    dispatch(editWaypoint({ data: event.target.value, dir: dir }))
  }

  const handleWaypoint = (e: React.MouseEvent): void => {
    axios({
      method: "post",
      url: process.env.REACT_APP_API_URI + "/settings/waypoint",
      data: { N: waypoint_north, E: waypoint_east },
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then(function (response) {
        dispatch(stopTyping());
        dispatch(setWaypoint(""));
        notify("Waypoint set to: "+waypoint_north+ ", " + waypoint_east, { backgroundColor: "#00FF00", autoCloseMs: 3000 });
      })
      .catch(function (response) {
      });
  }
  return (
    <>
      <div className=' flex justify-between items-center waypoint gap-1'>
        <p>Lat/Lon</p>
        <RangedInput defaultValue={waypoint_north} min={-90} max={90} reason="-90 < x > 90" inputType="text" placeholder="Latitude" onChange={(event) => handleInput(event, "N")} />
        <RangedInput defaultValue={waypoint_east} min={-180} max={180} reason="-180 < y > 180" inputType="text" placeholder="Longitude" onChange={(event) => handleInput(event, "E")} />
        <Button label="Set" width="fit" onClick={handleWaypoint}></Button>
      </div>
    </>
  )
}